import {
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useEffect
} from 'react'
import type { SetURLSearchParams } from 'react-router-dom'

import { camelCase } from 'lodash'

export const useHandleTab = (
  searchParams: URLSearchParams,
  setSearchParams: SetURLSearchParams,
  setTabValue: Dispatch<SetStateAction<number>>,
  tabComponents: { component: ReactNode; name: string }[]
) => {
  useEffect(() => {
    const currentTab = searchParams.get('tab')
    if (currentTab) {
      const tabIndex = tabComponents.findIndex(
        item => camelCase(item.name) === currentTab
      )

      if (tabIndex !== -1) {
        setTabValue(tabIndex)
      } else {
        setTabValue(0)
        setSearchParams(
          searchParams => {
            searchParams.set('tab', camelCase(tabComponents[0].name))
            return searchParams
          },
          {
            replace: true
          }
        )
      }
    } else {
      setTabValue(0)
      setSearchParams(
        searchParams => {
          searchParams.set('tab', camelCase(tabComponents[0].name))
          return searchParams
        },
        {
          replace: true
        }
      )
    }
  }, [searchParams, setSearchParams, setTabValue, tabComponents])
}
